var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "col-12 px-0 h-100" }, [
    _c("div", { staticClass: "container mw-100 d-lg-none" }, [
      _c("div", { staticClass: "row py-1" }, [
        _c("div", { staticClass: "col-12 text-center" }, [
          _c("img", { attrs: { alt: "", height: "50", src: _vm.iconEqual } }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("img", {
      staticClass: "picto-add d-none d-lg-block",
      attrs: { alt: "", src: _vm.iconEqual },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "d-lg-none" }, [
      _c(
        "div",
        {
          staticClass:
            "container mw-100 div-img border-gray bg-dark recommended-recap-total-tile mb-0 py-1",
        },
        [
          _c("div", { staticClass: "row py-1" }, [
            _c("div", { staticClass: "col-12 text-center text-white" }, [
              _c("h3", { staticClass: "mx-auto mb-0 h4" }, [
                _c("strong", [_vm._v(_vm._s(_vm.offersTotalPriceLabel))]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 text-center" },
              [
                _c("ob1-prix", {
                  attrs: {
                    custom: "text-primary",
                    duration: _vm.totalPrice.duration,
                    "initial-price": _vm.totalPrice.initialPrice,
                    "is-compact": _vm.totalPrice.compact,
                    "is-inverse": _vm.totalPrice.inverse,
                    price: _vm.totalPrice.price,
                    "price-details": _vm.totalPrice.priceDetails,
                    "show-by-month": _vm.totalPrice.showByMonth,
                    "show-end-of-promotion-price":
                      _vm.totalPrice.showEndOfPromotionPrice,
                    "show-from": _vm.totalPrice.showFrom,
                    "show-promo-duration": _vm.totalPrice.showPromoDuration,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.mobileOffer.discountLabelWithMobileOfferMention
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-12 d-flex align-items-center justify-content-center",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "my-1",
                        staticStyle: { width: "fit-content" },
                      },
                      [
                        _c("hr", { staticClass: "separator separator--gray4" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "my-1 d-flex align-items-center justify-content-center",
                          },
                          [
                            _c("span", {
                              staticClass:
                                "alert-icon icon-phone-fund-euro text-primary font-size-28 mr-1",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "ob1-alert-title font-weight-bold text-white",
                              },
                              [_vm._v(_vm._s(_vm.formattedMobileDiscountLabel))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("hr", { staticClass: "separator separator--gray4" }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 text-center" },
              [
                _c("generic-button-cta", {
                  attrs: {
                    "dto-from-object": _vm.genericButtonCta,
                    "css-classes": "btn-primary btn-inverse",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-none d-lg-block h-100" }, [
      _c(
        "div",
        {
          staticClass:
            "container mw-100 div-img d-flex align-content-center flex-wrap border-gray bg-dark h-100 recommended-recap-total-tile mb-0",
        },
        [
          _c("div", { staticClass: "row py-1" }, [
            _c("div", { staticClass: "col-12 text-center text-white" }, [
              _c("h3", { staticClass: "mb-0 h4" }, [
                _c("strong", [_vm._v(_vm._s(_vm.offersTotalPriceLabel))]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 text-center" },
              [
                _c("ob1-prix", {
                  attrs: {
                    custom: "text-primary",
                    duration: _vm.totalPrice.duration,
                    "initial-price": _vm.totalPrice.initialPrice,
                    "is-compact": _vm.totalPrice.compact,
                    "is-inverse": _vm.totalPrice.inverse,
                    price: _vm.totalPrice.price,
                    "price-details": _vm.totalPrice.priceDetails,
                    "show-by-month": _vm.totalPrice.showByMonth,
                    "show-end-of-promotion-price":
                      _vm.totalPrice.showEndOfPromotionPrice,
                    "show-from": _vm.totalPrice.showFrom,
                    "show-promo-duration": _vm.totalPrice.showPromoDuration,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.mobileOffer.discountLabelWithMobileOfferMention
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-12 d-flex align-items-center justify-content-center",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "my-1",
                        staticStyle: { width: "fit-content" },
                      },
                      [
                        _c("hr", { staticClass: "separator separator--gray4" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "my-1 d-flex align-items-center justify-content-center",
                          },
                          [
                            _c("span", {
                              staticClass:
                                "alert-icon icon-phone-fund-euro text-primary font-size-28 mr-1",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "ob1-alert-title font-weight-bold text-white",
                              },
                              [_vm._v(_vm._s(_vm.formattedMobileDiscountLabel))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("hr", { staticClass: "separator separator--gray4" }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 text-center" },
              [
                _c("generic-button-cta", {
                  attrs: {
                    "dto-from-object": _vm.genericButtonCta,
                    "css-classes": "btn-primary btn-inverse",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }